/** На основе спецификации в http://vos.openlinksw.com/owiki/wiki/VOS/VOSSparqlProtocol  */
import 'whatwg-fetch';
import _ from 'lodash';
import settings from './settings';
import Client from './client/client';
import {Request} from './request';
import LiferayApiUtils from '../liferay/ApiUtils';
import LiferaySettings from '../liferay/settings';

//Флаг, что вызовы нужно делать через Liferay
const viaLiferay = true;

function getVirtuosoAuthToken() {
    if (window.Virtuoso) {
        return window.Virtuoso.authToken;
    }
    return settings.p_auth;
}

function getQueryString(params) {
    const esc = encodeURIComponent;
    return _.keys(params)
        .map(k => `${esc(k)}=${esc(params[k])}`)
        .join('&');
}

const getUrl = (url, queryParams) => {
    if (_.keys(queryParams).length > 0) {
        url += `?${getQueryString(queryParams)}`;
    }
    return url;
};

export const getVirtuosoUrl = () => {
    if (!window.Virtuoso) {
        return settings.virtuosoUrl;
    }
    return `${settings.virtuosoUrl}?p_auth=${getVirtuosoAuthToken()}`;
};

/**
 * Список клиентов Virtuoso по endpointUrl
 */
const vclients = new Map();

const VirtuosoClient = new Client(settings.endpointUrl);
vclients.set(settings.endpointUrl, VirtuosoClient);

const QUERIES_LONGER_THEN = 1900;
const ApiUtils = {

    register_endpointUrl(endpointUrl){
        vclients.set(endpointUrl, new Client(endpointUrl));
    },

    clientByEndpointUrl(endpointUrl){
        return vclients.has(endpointUrl) ? vclients.get(endpointUrl) : VirtuosoClient;
    },


    /** Вызов метода sparql_select_json mpo-сервиса в Liferay */
    queryViaLiferay(sparql, graph) {
        const options = {...LiferaySettings.options};
        const formData = {
          'cmd': JSON.stringify({'/mpo.mpo/sparql_select_json':{}}),
          'default_graph_uri': graph,
          'query': sparql,
        }
        return LiferayApiUtils.postToLifeRay721(formData, options);
    },

    /** Вызов метода graph_presentation mpo-сервиса в Liferay */
    presentationViaLiferay(view, ID) {
        const options = {...LiferaySettings.options};
        const formData = {
          'cmd': JSON.stringify({'/mpo.mpo/graph_presentation':{}}),
          'view': view,
          'ID': ID
        }
        return LiferayApiUtils.postToLifeRay721(formData, options);
    },

    /** Вызов метода get_process_info mpo-сервиса в Liferay */
    getProcessInfoViaLiferay(ID) {
        const options = {...LiferaySettings.options};
        const formData = {
          'cmd': JSON.stringify({'/mpo.mpo/get_process_info':{}}),
          'id': ID
        }
        return LiferayApiUtils.postToLifeRay721(formData, options);
    },

    /** sparql - класс Request (из request.js) в котором задано  тело sparql запроса и граф
     * , params - параметры в url, options в запросе*/
    query(request, params = {}, options = {}) {
        //см. раздел HTTP Request Methods, в котором определена длина, при которой необходимо
        //выполнять POST запрос (1900 байт)
        //console.log("query(request, params = {}, options = {})", request, params, options);
        if ((request==null)||(request==undefined)|| !(request instanceof Request))
            return Promise.reject("SPARQL is null or undefined! ");
        const sparql = request.sparql;
        if (viaLiferay){
            return this.queryViaLiferay(sparql, request.graph);
        }
        if (sparql.length>QUERIES_LONGER_THEN){
            options.method = 'post';
        } else {
            options.method = 'get';
        }
        if (!options.headers) options.headers = {};
        if (!options.headers["Content-type"]) options.headers["Content-type"]='application/json';
        //Если есть объект, содержащий характеристики подключения к Virtuoso
        if (!window.Virtuoso) {
            options.headers.Authorization = `Basic ${btoa(`${settings.virtuoso_username}:${settings.virtuoso_password}`)}`
        } else {
        	params.p_auth = getVirtuosoAuthToken();
        }
        return this.fetch(sparql, request.graph, params, options);
    },

    /** Запрос mpo сервиса sparql_select */
    querySelect(request) {
        if ((request==null)||(request==undefined)|| !(request instanceof Request))
            return Promise.reject("SPARQL is null or undefined! ");
        const options = {...LiferaySettings.options};
        const formData = {
          'cmd': JSON.stringify({'/mpo.mpo/sparql_select':{}}),
          'default_graph_uri': request.graph,
          'query': request.sparql,
        }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                const data = typeof response === "string" ? JSON.parse(response) : response;                
                return Promise.resolve(data);
        });
    },


    fetch(sparql, graph=null, params = {}, options = {}) {
        //Специальный Promise для обработки таймаута
        const timeout = new Promise((resolve, reject) => {
            setTimeout(
                () =>
                    reject(
                        new Error({
                            message: "Connection to the Internet couldn't be established",
                        })
                    ),
                settings.loadTimeout
            );
        });

        let {endpointUrl} = settings;
        if (options.endpointUrl) {
            // eslint-disable-next-line prefer-destructuring    
            endpointUrl = options.endpointUrl;
        }
        const client = this.clientByEndpointUrl(endpointUrl);
        const getData = new Promise((resolve, reject) => {
            return client.query(sparql, graph, params, options)
            //return VirtuosoClient.query(sparql, graph, params, options)
                .then(response => ApiUtils.checkStatus(response))
                .then(response => {
                    if (options.type === 'text') {
                        return response.text();
                    }
                    return response.json();
                })
                .then(json => {
                    resolve(json);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return Promise.race([timeout, getData]);
    },

    checkStatus(response) {
        if (response.type === 'opaque') return response;
        if (response.status >= 200 && response.status < 300) {
            return response;
        }
        throw (response.error) ? response.error : `Ответ сервиса: ${response.statusText} (${response.status}).`;
    },
    convertToSelectOptions(list) {
        return _.map(list, obj => ({value: obj.id, label: obj.name}));
    },
    convertToSelectOption(option) {
        if (option == null || !option.id) return '';
        return {value: option.id, label: option.name};
    }
};

export default ApiUtils;
